import { RequestQuote } from "@mui/icons-material";
import {
  BooleanField,
  Datagrid,
  DateField,
  List,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  TextInput,
  NumberField,
  ReferenceField,
} from "react-admin";
import { CardListActions } from "../../components";

const filters = [
  <TextInput source="submitter_first_name" alwaysOn label="First Name" />,
  <TextInput source="submitter_last_name" alwaysOn label="Last Name" />,
  <TextInput source="submitter_email" alwaysOn label="Email" />,
  <TextInput source="submitter_phone" label="Phone" />,
  <TextInput source="referrer" label="Referrer" />,
];

function ListView(props) {
  return (
    <List
      {...props}
      actions={<CardListActions exporter={true} />}
      filters={filters}
      perPage={25}
      sort={{ field: "created_at", order: "DESC" }}
      title="Dedication Submissions"
    >
      <Datagrid rowClick="show">
        <DateField source="created_at" label="Submitted" showTime />
        <TextField source="submitter_first_name" label="First Name" />
        <TextField source="submitter_last_name" label="Last Name" />
        <TextField source="submitter_email" label="Email" />
        <TextField source="submitter_phone" label="Phone" />
        <NumberField
          source="price"
          label="Price"
          options={{ style: "currency", currency: "USD" }}
        />
        <TextField source="referrer" label="Referrer" />
        <ReferenceField
          source="donation_id"
          reference="donations"
          label="Donation"
          link="show"
        >
          <TextField source="id" />
        </ReferenceField>
      </Datagrid>
    </List>
  );
}

function ShowView(props) {
  return (
    <Show {...props}>
      <TabbedShowLayout>
        <Tab label="Submission Details">
          <DateField source="created_at" showTime label="Submitted At" />
          <TextField source="submitter_first_name" label="First Name" />
          <TextField source="submitter_last_name" label="Last Name" />
          <TextField source="submitter_email" label="Email" />
          <TextField source="submitter_phone" label="Phone" />
          <NumberField
            source="price"
            label="Price"
            options={{ style: "currency", currency: "USD" }}
          />
          <TextField source="referrer" label="Referrer" />
          <ReferenceField
            source="donation_id"
            reference="donations"
            label="Donation"
            link="show"
          >
            <TextField source="id" />
          </ReferenceField>
          {/* Keep manual audit metadata detail-only so it does not affect lists or exports. */}
          <BooleanField
            source="is_admin_manual_submission"
            label="Admin Manual Submission"
          />
          <TextField
            source="admin_manual_submission_type"
            label="Manual Submission Type"
          />
          <ReferenceField
            source="admin_manual_submission_created_by_user_id"
            reference="users"
            label="Created By User"
            link="edit"
          >
            <TextField source="id" />
          </ReferenceField>
          <TextField
            source="admin_manual_submission_chosen_backfill_direction"
            label="Chosen Backfill Direction"
          />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
}

export const DedicationSubmissions = {
  category: "database",
  name: "dedication_submissions",
  icon: RequestQuote,
  list: ListView,
  options: { label: "Dedication Submissions" },
  show: ShowView,
};
